import * as React from 'react'
import Box from '@mui/material/Box'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'

export interface IValue {
  id: number
  label: string
}

interface IDropDownProps {
  label?: string
  subLabel?: string
  onChange: (values: IValue) => void
  width?: string
  defaultValue?: IValue
  values?: IValue[]
  isLoading?: boolean
  disabled?: boolean
}

const DropDown: React.FC<IDropDownProps> = ({
  label,
  subLabel,
  onChange,
  width,
  defaultValue,
  values,
  isLoading,
  disabled,
}) => {
  const foundValue =
    defaultValue && values?.find((value) => value.id === defaultValue.id)
  const [selectedValue, setSelectedValue] = React.useState<IValue | undefined>(
    foundValue,
  )

  React.useEffect(() => {
    setSelectedValue(defaultValue)
  }, [defaultValue])

  const handleChange = (event: SelectChangeEvent) => {
    const valueId = Number(event.target.value)
    const foundScene = values?.find((value) => value.id === valueId)
    setSelectedValue(foundScene)
    onChange(foundScene)
  }

  return (
    <Box sx={{ width: width ? width : '100%', marginBottom: '20px' }}>
      <FormControl fullWidth>
        <InputLabel>{label}</InputLabel>
        <Select
          value={selectedValue ? selectedValue.id.toString() : ''}
          label={label}
          onChange={handleChange}
          disabled={disabled || isLoading}
        >
          {subLabel && (
            <MenuItem disabled value={-1}>
              {subLabel}
            </MenuItem>
          )}
          {values?.map((value, index) => (
            <MenuItem key={index} value={value.id}>
              {value.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  )
}

export default DropDown
